import { render, staticRenderFns } from "./WebSettings.vue?vue&type=template&id=13152720&scoped=true&"
import script from "./WebSettings.vue?vue&type=script&lang=js&"
export * from "./WebSettings.vue?vue&type=script&lang=js&"
import style0 from "./WebSettings.vue?vue&type=style&index=0&id=13152720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13152720",
  null
  
)

export default component.exports